module.exports = __webpack_public_path__ + "img/banner-fabrica-cover.38ab5f0c.jpeg";